import { useContext, useEffect } from "react";
import { DRAFT_ACTIONS } from "../../../components/draft/draftReducer";
import DraftDispatchContext from "../../../contexts/draftDispatchContext";
import useDraftId from "./useDraftId";
import useGetter from "../useGetter";
import useSeason from "../useSeason";
import useUserTeam from "../useUserTeam";

export default function useDraftTeamWatchList() {
  const season = useSeason();
  const draftId = useDraftId();
  const userTeam = useUserTeam();
  const draftDispatch = useContext(DraftDispatchContext);

  const enabled = !!season && !!draftId && !!userTeam && userTeam.hasLoaded();

  let teamId = null;
  if (enabled) teamId = userTeam.obj.id;

  const draftTeamWatchUrl = `/player-lists/${season}/watch/draft/${draftId}/team/${teamId}`;
  const { data: draftTeamWatchData, query: draftTeamWatchQuery } = useGetter(
    draftTeamWatchUrl,
    { enabled }
  );

  let playerIds = [];
  let playerIdsString = "";
  if (draftTeamWatchData) {
    playerIds = Object.values(draftTeamWatchData.playerList.entries);
    playerIdsString = playerIds.join(",");
  }

  useEffect(() => {
    draftDispatch({
      type: DRAFT_ACTIONS.SET_WATCH_LIST,
      payload: playerIdsString,
    });
  }, [playerIdsString, draftDispatch]);

  return { draftTeamWatchUrl, draftTeamWatchData, draftTeamWatchQuery };
}
